import { createStore } from '@stencil/store';

export const { state, onChange, dispose } = createStore({
    isUserLoggedIn: false,
    cognitoIdToken: '',
    cognitoAccessToken: '',
    modalInitialized: {},
    showModal: (_instanceId: string) => {},
    hideModal: (_instanceId: string) => {},
    isUserFraudulent: true,
    isVerified: false,
    isADILoading: true,
    riskAssessment: 'medium',
    fraudCheckComplete: false,
    makeOfferValue: 0,
});

// Listen to changes and update value
onChange('isUserLoggedIn', value => {
    state.isUserLoggedIn = value;
});

onChange('isADILoading', value => {
    state.isADILoading = value;
});

onChange('cognitoIdToken', value => {
    state.cognitoIdToken = value;
});

onChange('modalInitialized', value => {
    state.modalInitialized = value;
});

onChange('isUserFraudulent', value => {
  state.isUserFraudulent = value;
});

onChange('fraudCheckComplete', value => {
    state.fraudCheckComplete = value;
});

onChange('makeOfferValue', value => {
  state.makeOfferValue = value;
});

export default state;
